<template>
<div class="chapter">
<div class="inner_page">
<p class="PN" id="pt001"><a id="page_29"></a><a href="#/xhtml/contents#pt-001">I.<span class="space05">The Synoptic Gospels</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?3a6a650d